




































import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component, Prop } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { actionsEvent } from '@/setup';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import Confirmation from '@/components/Confirmation.vue';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchOrdenSerTec } from './fetchOrdenSerTec';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';

import { forEach } from 'lodash';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';
const { AgGridVue } = require('ag-grid-vue');

@Component({
  components: {
    MantenedorGrid,
    AgGridVue,
  },
})
export default class TablaSeriesTodos extends ComponenteBase {
  @Prop({ default: false }) DispositivosTotalesPorTecnico: boolean;
  @Prop({ default: false }) id_tecnico_seleccionado: boolean;
  @Prop({ default: null }) id_alta_serv: any;

  accionesTotales: PermisoAccion[];
  filtro: string = '';
  ordesList: any[] = [];

  funcionalidad: Funcionalidades = Funcionalidades.detalleAltasServicioTecnico;
  usuario = JSON.parse(localStorage.getItem('user')).id;

  cerrarModal() {
    this.$emit('cerrarModal', false);
  }

  mounted() {}
  finales: any;

  guardar() {
    this.finales = this.selectedRows;
    console.log('this.finales en el metodo guardar()', this.finales);
    if (this.finales.length > 0) {
      console.log('*****  ALTA SERVICIO ' + this.id_alta_serv + ' *****');
      this.$emit('selected', this.finales);
      this.$emit('DispositivosTotalesPorTecnico', false);
    } else {
      this.$snotify.error('Sin detalle seleccionado');
    }
  }

  async getSeriesTodos() {
    //trae los items en la ubicacion del tecnico. es la grilla al boton agregar
    let self = this;
    this.loadingService.showLoading(undefined, 'getSeriesTodos');
    return fetchOrdenSerTec(
      {
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '171',
        id_tecnico: this.id_tecnico_seleccionado,
      },
      'conecta_ordenes_sertec/get_serials_por_ubicacion_tenico'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('getSeriesTodos');
        if (data.data.CODIGO_RESPUESTA == '1') {
          console.log('resultado getSeriesTodos', data.data);
          return data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error(error, { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async recargarInformacion() {
    //carga la grilla con los items de la ubicacion del tecnico seleccionado en la grilla del boton agregar
    console.log('llama recargarInformacion');
    this.ordesList = await this.getSeriesTodos();
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  async handleGridReady(event: GridReadyEvent) {
    //este metodo se llama en el editar para cargar la grilla con lo que la alta de servicio tenia previamente cargado
    this.ordesList = [];
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    console.log('this.ordesList en el handleGridReady', this.ordesList);
    //const updateData = (data: any) => this.gridApi.setRowData(data);
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  selectedRows: any = [];

  onSelectionChanged(params: any) {
    //se llama al clickear un checkbox en la lista, va agregando al array los items a medida se van seleccionando
    this.selectedRows = this.gridApi.getSelectedRows();
    console.log(
      'this.selectedRows en el metodo onSelectionChanged()',
      this.selectedRows
    );
  }

  // Globales
  tabModel: string = 'tab-3';
  muestraBarraBotones: boolean = false;
  registrosAsociar: any = [];
  rowsPerPageItems: any = [];
  dialog: Boolean = false;
  search: string = '';
  localeText: any = config.agGridTextos;
  gridOptions: GridOptions;
  showTabPerfiles: boolean = true;
  showTabRoles: boolean = true;
  loadingService = new LoadingService();
  paramsExportar: any; //Parametros para Exportar
  intervalo: any; //Intervalo para el buscador
  chequearPermisosBtnCrear: boolean = true;
  editedIndex: number = -1;
  nombreModulo: string = '';
  handleErrors: HandleErrors = new HandleErrors();

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  agGridUtil: AgGridUtil;
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;

  dateFormatter(params: any) {
    return moment(params.value).format('MM/DD/YYYY');
  }

  constructor() {
    super();
    this.columnDefs = [
      {
        minWidth: 70,
        width: 75,
        checkboxSelection: true,
      },
      {
        headerName: 'Número de serie',
        field: 'serienumero',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Equipo',
        field: 'tipoeqname',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
      },

      {
        headerName: 'ID Dispostivo',
        field: 'altaserid_dispositivo',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
      },

      {
        headerName: 'Número Activación',
        field: 'serieactivanro',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Plataforma',
        field: 'plataforma',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Número Serie SIM',
        field: 'simserienumero',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
      },
      {
        headerName: 'Estado SIM',
        field: 'estadosim',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 200,
        width: 200,
      },
    ];

    this.gridOptions = {
      localeText: {
        noRowsToShow:
          'No hay dispositivos seriados disponibles en tu ubicación',
      },
      pagination: true,
      paginationPageSize: 10, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'multiple',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,
      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  moduloModalCallback(val: boolean) {
    this.showModalEdit = val;
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    console.log(id);
    return id;
  }

  getCliente() {
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }
}
